import { CalculateMarginPayloadProps, QuotationProps } from '@/types'

export const getQuotationMetricsPayload = ({
  quotationValues,
}: {
  quotationValues: QuotationProps
}): CalculateMarginPayloadProps => {
  return {
    items: quotationValues?.products?.map((product) => ({
      cost: Number(product.cost) || 0,
      price: Number(product.price) || 0,
      quantity: Number(product.quantity) || 0,
      traderCommission: Number(product.traderCommission) || 0,
    })),
    customsFreightCost: quotationValues.customsFreightCost,
    deliveryOption: quotationValues.deliveryOption,
    discount: Number(quotationValues.discount || 0),
    financingCost: Number(quotationValues.financingCost) || undefined,
    firstMileFreightCost: Number(quotationValues.firstMileFreightCost || 0),
    includeIva: quotationValues?.includeIva || false,
    lastMileFreightCost: Number(quotationValues.lastMileFreightCost || 0),
    totalFreightPrice: Number(quotationValues.totalFreightPrice || 0),
    creditGateway:
      quotationValues?.buyerProfile?.financeProfile?.creditGateway || undefined,
  }
}

export function getDateWithWeekdayOffset() {
  const now = new Date()

  const weekday = now.getDay()
  let daysToAdd = 7
  switch (weekday) {
    case 1: // Monday
      daysToAdd = 7
      break
    case 2: // Tuesday
    case 3: // Wednesday
    case 4: // Thursday
      daysToAdd = 8
      break
    case 5: // Friday
      daysToAdd = 10
      break
    default:
      daysToAdd = 10
  }

  const futureDate = new Date(now)
  futureDate.setDate(futureDate.getDate() + daysToAdd)

  const pad = (num: number, size = 2) => String(num).padStart(size, '0')

  const tzOffset = -futureDate.getTimezoneOffset()
  const sign = tzOffset >= 0 ? '+' : '-'
  const offsetHours = pad(Math.floor(Math.abs(tzOffset) / 60))
  const offsetMinutes = pad(Math.abs(tzOffset) % 60)
  const offsetFormatted = `${sign}${offsetHours}${offsetMinutes}`

  const formatted =
    `${futureDate.getFullYear()}-${pad(futureDate.getMonth() + 1)}-${pad(
      futureDate.getDate(),
    )} ` +
    `${pad(futureDate.getHours())}:${pad(futureDate.getMinutes())}:${pad(
      futureDate.getSeconds(),
    )}.${pad(futureDate.getMilliseconds(), 3)} ${offsetFormatted}`

  return formatted
}
